/* eslint-disable jsx-a11y/no-static-element-interactions */
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye, faEyeSlash } from '@fortawesome/sharp-solid-svg-icons';
import React, { FC, useState } from 'react';
import { twMerge } from 'tailwind-merge';

import { useCustomizeLandContext } from '@/features/customizeMyLand/provider';
import { hideFeature } from '@/features/customizeMyLand/util';

interface CustomizedLandHideAllButtonProps {
  className?: string;
  iconClassName?: string;
}

const CustomizeLandHideAllButton: FC<CustomizedLandHideAllButtonProps> = ({
  className = '',
  iconClassName = '',
}) => {
  const [showAll, setShowAll] = useState(true); // Note: This may need to move to context when we add in save/fetching
  const { customizations, drawTool, updateDrawFeature } =
    useCustomizeLandContext();

  return (
    // eslint-disable-next-line jsx-a11y/click-events-have-key-events
    <div
      className={twMerge(
        'flex h-10 w-10 items-center justify-center',
        className
      )}
      onClick={(e) => {
        e.stopPropagation();
        customizations.allCustomizations.forEach((feat) => {
          hideFeature(feat, drawTool, showAll, updateDrawFeature);
        });
        setShowAll((prev) => !prev);
      }}
    >
      <FontAwesomeIcon
        className={twMerge(
          'p-0 text-white',
          showAll ? 'h-4 w-4' : 'h-5 w-5',
          iconClassName
        )}
        icon={showAll ? faEye : faEyeSlash}
      />
    </div>
  );
};

export default CustomizeLandHideAllButton;
